import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from "@angular/router";


@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent implements OnInit {
  user;
  type;
  extra = true;
    constructor(private viewportScroller: ViewportScroller,private router: Router) { }

  ngOnInit(): void {

    this.user = JSON.parse(localStorage.getItem('clpUser'));
    if (localStorage.getItem("clpUser") != null) {
      // alert("11")
      this.extra = false;

    }
  }
  gotoScroll(itemId:string){
    this.viewportScroller.scrollToAnchor(itemId);
  }
  logout() {

    // this.router.navigate(['/account/login']);
    localStorage.clear();
     this.router.navigate(['/account/login']).then(() => {
    window.location.reload();
  });
  }
  dashboard() {
    this.user = JSON.parse(localStorage.getItem('clpUser')).type
    if (this.user == 1) {
      this.router.navigate(['/buyer/marketplace']);
    } else {
      this.router.navigate(['/seller/contentlist']);
    }

  }
}
